import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";

import integrante1 from "../../static/media/nosotros/Integrante_5.jpeg";
import integrante2 from "../../static/media/nosotros/Integrante_4.jpeg";
import integrante3 from "../../static/media/nosotros/Integrante_3.jpeg";
import integrante4 from "../../static/media/nosotros/Integrante_2.jpeg";
import integrante5 from "../../static/media/nosotros/Integrante_1.jpeg";

const C = {
  dark: "#0C1F2F",
  navy: "#0057A8",
  navyDark: "#003D73",
  gold: "#FFCD00",
  teal: "#5BC8AF",
  gray: "#F5F7FA",
  white: "#ffffff",
};

const EQUIPO = [
  { id: 1, rol: "Logística", img: integrante1 },
  { id: 2, rol: "Ventas", img: integrante2 },
  { id: 3, rol: "Ventas", img: integrante3 },
  { id: 4, rol: "Bodeguero", img: integrante4 },
  { id: 5, rol: "Marketing", img: integrante5 },
];

export default function NuestroEquipo() {
  return (
    <Box
      sx={{
        background: C.white,
        pt: { xs: "64px", md: "88px" },
        pb: 0,
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          maxWidth: "1280px",
          mx: "auto",
          px: { xs: "20px", sm: "32px", md: "40px" },
          boxSizing: "border-box",
          width: "100%",
        }}
      >
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "flex-start", md: "flex-end" },
            justifyContent: "space-between",
            gap: 2,
            mb: { xs: 5, md: 7 },
          }}
        >
          <Box>
            <Typography
              variant="h2"
              sx={{
                color: C.dark,
                fontWeight: 900,
                fontSize: { xs: 28, sm: 34, md: 42 },
                letterSpacing: "-.02em",
                lineHeight: 1.1,
              }}
            >
              ¡Nuestro Equipo!
            </Typography>
            <Typography
              sx={{ color: "#8a9aaa", mt: 1, fontSize: { xs: 13.5, md: 15 } }}
            >
              El talento humano detrás de cada proyecto exitoso.
            </Typography>
          </Box>
          <Box
            sx={{
              display: { xs: "none", md: "block" },
              flex: 1,
              height: "1px",
              background: "rgba(0,0,0,0.08)",
              ml: 4,
              mb: "10px",
            }}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: { xs: "16px", sm: "20px", md: "28px" },
          }}
        >
          {EQUIPO.map((miembro, index) => (
            <Box
              key={miembro.id}
              component={motion.div}
              initial={{ opacity: 0, scale: 0.94 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
              whileHover={{ y: -8, transition: { duration: 0.22 } }}
              sx={{
                width: {
                  xs: "calc(50% - 8px)",
                  sm: "calc(33.333% - 14px)",
                  md: "calc(20% - 23px)",
                },
                minWidth: "130px",
                maxWidth: "220px",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  aspectRatio: "3/4",
                  borderRadius: "16px",
                  overflow: "hidden",
                  position: "relative",
                  boxShadow: "0 6px 20px rgba(0,0,0,.09)",
                  transition: "box-shadow .25s",
                  "&:hover": { boxShadow: "0 16px 36px rgba(0,0,0,.16)" },
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "45%",
                    background:
                      "linear-gradient(0deg, rgba(0,61,115,0.80) 0%, transparent 100%)",
                    pointerEvents: "none",
                  },
                }}
              >
                <Box
                  component="img"
                  src={miembro.img}
                  alt={`${miembro.rol}`}
                  onError={(e) => {
                    e.currentTarget.src =
                      "https://via.placeholder.com/300x400?text=Foto";
                  }}
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                    transition: "transform 0.45s ease",
                    "&:hover": { transform: "scale(1.05)" },
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    bottom: "12px",
                    left: 0,
                    right: 0,
                    zIndex: 2,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      color: C.white,
                      fontWeight: 700,
                      fontSize: "11px",
                      letterSpacing: ".10em",
                      textTransform: "uppercase",
                      textShadow: "0 1px 4px rgba(0,0,0,0.5)",
                    }}
                  >
                    {miembro.rol}
                  </Typography>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>

      {/* Unión final (blanco hacia azul) si abajo va el footer u otra sección azul */}
      <Box
        sx={{
          height: { xs: "60px", md: "80px" },
          background: `linear-gradient(180deg, ${C.white} 0%, ${C.navy} 100%)`,
          mt: { xs: 7, md: 10 },
        }}
      />
    </Box>
  );
}
